import {
  Col,
  Row,
  Image,
  Tooltip,
  Input,
  Table,
  Checkbox,
  InputNumber,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useEffect, useState } from "react";

import test0apng from "../images/4foto/001a.png";
import test0bpng from "../images/4foto/001b.png";
import test0cpng from "../images/4foto/001c.png";

import test1apng from "../images/4foto/1a.png";
import test1bpng from "../images/4foto/1b.png";
import test1cpng from "../images/4foto/1c.png";

import test2apng from "../images/4foto/2a.png";
import test2bpng from "../images/4foto/2b.png";
import test2cpng from "../images/4foto/2c.png";

import test3apng from "../images/4foto/3a.png";
import test3bpng from "../images/4foto/3b.png";
import test3cpng from "../images/4foto/3c.png";

import test4apng from "../images/4foto/4a.png";
import test4bpng from "../images/4foto/4b.png";
import test4cpng from "../images/4foto/4c.png";

import test5apng from "../images/4foto/5a.png";
import test5bpng from "../images/4foto/5b.png";
import test5cpng from "../images/4foto/5c.png";

import test6apng from "../images/4foto/6a.png";
import test6bpng from "../images/4foto/6b.png";
import test6cpng from "../images/4foto/6c.png";

import test7apng from "../images/4foto/7a.png";
import test7bpng from "../images/4foto/7b.png";
import test7cpng from "../images/4foto/7c.png";

import test8apng from "../images/4foto/8a.png";
import test8bpng from "../images/4foto/8b.png";
import test8cpng from "../images/4foto/8c.png";
import test8dpng from "../images/4foto/8d.png";
import test8epng from "../images/4foto/8e.png";

import test9apng from "../images/4foto/9a.png";
import test9bpng from "../images/4foto/9b.png";
import test9cpng from "../images/4foto/9c.png";

import test10apng from "../images/4foto/10a.png";
import test10bpng from "../images/4foto/10b.png";
import test10cpng from "../images/4foto/10c.png";

import test11apng from "../images/4foto/11a.png";
import test11bpng from "../images/4foto/11b.png";
import test11cpng from "../images/4foto/11c.png";

import test12apng from "../images/podo/12a.png";
import test12bpng from "../images/podo/12b.png";
import test12cpng from "../images/podo/12c.png";

import test13apng from "../images/podo/13a.png";
import test13bpng from "../images/podo/13b.png";
import test13cpng from "../images/podo/13c.png";
import test13dpng from "../images/podo/13d.png";
import test13epng from "../images/podo/13e.png";
import test13fpng from "../images/podo/13f.png";
import test13gpng from "../images/podo/13g.png";

import test14apng from "../images/podo/14a.png";
import test14bpng from "../images/podo/14b.png";
import test14cpng from "../images/podo/14c.png";
import test14dpng from "../images/podo/14d.png";
import test14epng from "../images/podo/14e.png";
import test14fpng from "../images/podo/14f.png";
import test14gpng from "../images/podo/14g.png";

import test15apng from "../images/podo/15a.png";
import test15bpng from "../images/podo/15b.png";
import test15cpng from "../images/podo/15c.png";

import test16apng from "../images/aaii/16a.png";
import test16bpng from "../images/aaii/16b.png";
import test16cpng from "../images/aaii/16c.png";
import test16dpng from "../images/aaii/16d.png";

import test17apng from "../images/aaii/17a.png";
import test17bpng from "../images/aaii/17b.png";
import test17cpng from "../images/aaii/17c.png";
import test17dpng from "../images/aaii/17d.png";

import test18apng from "../images/aaii/18a.png";
import test18bpng from "../images/aaii/18b.png";
import test18cpng from "../images/aaii/18c.png";

import test19apng from "../images/aaii/19a.png";
import test19bpng from "../images/aaii/19b.png";
import test19cpng from "../images/aaii/19c.png";

import test20apng from "../images/aaii/20a.png";
import test20bpng from "../images/aaii/20b.png";
import test20cpng from "../images/aaii/20c.png";

import test21apng from "../images/aaii/21a.png";
import test21bpng from "../images/aaii/21b.png";
import test21cpng from "../images/aaii/21c.png";

import test22apng from "../images/aaii/22a.png";
import test22bpng from "../images/aaii/22b.png";
import test22cpng from "../images/aaii/22c.png";

import test23apng from "../images/aaii/23a.png";
import test23bpng from "../images/aaii/23b.png";
import test23cpng from "../images/aaii/23c.png";

import test24apng from "../images/aaii/24a.png";
import test24bpng from "../images/aaii/24b.png";
import test24cpng from "../images/aaii/24c.png";

import test25apng from "../images/aaii/25a.png";
import test25bpng from "../images/aaii/25b.png";
import test25cpng from "../images/aaii/25c.png";

import test26apng from "../images/aaii/26a.png";
import test26bpng from "../images/aaii/26b.png";
import test26cpng from "../images/aaii/26c.png";

import test27apng from "../images/aaii/27a.png";
import test27bpng from "../images/aaii/27b.png";
import test27cpng from "../images/aaii/27c.png";

import test28apng from "../images/aaii/28a.png";
import test28bpng from "../images/aaii/28b.png";
import test28cpng from "../images/aaii/28c.png";

import test29apng from "../images/vision/29a.png";
import test29bpng from "../images/vision/29b.png";
import test29cpng from "../images/vision/29c.png";

import test30apng from "../images/vision/30a.png";
import test30bpng from "../images/vision/30b.png";
import test30cpng from "../images/vision/30c.png";
import test30dpng from "../images/vision/30d.png";

import test31apng from "../images/stim/31a.png";
import test31bpng from "../images/stim/31b.png";
import test31cpng from "../images/stim/31c.png";
import test31dpng from "../images/stim/31d.png";
import test31epng from "../images/stim/31e.png";

import test32apng from "../images/stim/32a.png";
import test32bpng from "../images/stim/32b.png";

import test33apng from "../images/stim/33a.png";
import test33bpng from "../images/stim/33b.png";

import test34apng from "../images/stim/34a.png";
import test34bpng from "../images/stim/34b.png";
import test34cpng from "../images/stim/34c.png";
import test34dpng from "../images/stim/34d.png";

import test35apng from "../images/stim/35a.png";
import test36apng from "../images/stim/36a.png";

import _1st1 from "../images/stim/1st1.png";
import _1st15 from "../images/stim/1st15.png";
import _1st2 from "../images/stim/1st2.png";
import _1st25 from "../images/stim/1st25.png";
import _1st3 from "../images/stim/1st3.png";

import _3st1 from "../images/stim/3st1.png";
import _3st15 from "../images/stim/3st15.png";
import _3st2 from "../images/stim/3st2.png";
import _3st25 from "../images/stim/3st25.png";
import _3st3 from "../images/stim/3st3.png";

import _4st1 from "../images/stim/4st1.png";
import _4st15 from "../images/stim/4st15.png";
import _4st2 from "../images/stim/4st2.png";
import _4st25 from "../images/stim/4st25.png";
import _4st3 from "../images/stim/4st3.png";

import _5st1 from "../images/stim/5st1.png";
import _5st15 from "../images/stim/5st15.png";
import _5st2 from "../images/stim/5st2.png";
import _5st25 from "../images/stim/5st25.png";
import _5st3 from "../images/stim/5st3.png";

import _6st1 from "../images/stim/6st1.png";
import _6st15 from "../images/stim/6st15.png";
import _6st2 from "../images/stim/6st2.png";
import _6st25 from "../images/stim/6st25.png";
import _6st3 from "../images/stim/6st3.png";

import _7st1 from "../images/stim/7st1.png";
import _7st15 from "../images/stim/7st15.png";
import _7st2 from "../images/stim/7st2.png";
import _7st25 from "../images/stim/7st25.png";
import _7st3 from "../images/stim/7st3.png";

import _8st1 from "../images/stim/8st1.png";
import _8st15 from "../images/stim/8st15.png";
import _8st2 from "../images/stim/8st2.png";
import _8st25 from "../images/stim/8st25.png";
import _8st3 from "../images/stim/8st3.png";

import test41apng from "../images/magno/41a.png";
import test41bpng from "../images/magno/41b.png";
import test41cpng from "../images/magno/41c.png";

import test42apng from "../images/magno/42a.png";
import test42bpng from "../images/magno/42b.png";
import test42cpng from "../images/magno/42c.png";

import test43apng from "../images/magno/43a.png";
import test43bpng from "../images/magno/43b.png";
import test43cpng from "../images/magno/43c.png";

import test44apng from "../images/magno/44a.png";
import test44bpng from "../images/magno/44b.png";
import test44cpng from "../images/magno/44c.png";

import test45apng from "../images/magno/45a.png";
import test45bpng from "../images/magno/45b.png";
import test45cpng from "../images/magno/45c.png";

import test46apng from "../images/magno/46a.png";
import test46bpng from "../images/magno/46b.png";

import test48apng from "../images/magno/48a.png";
import test48bpng from "../images/magno/48b.png";

import test49apng from "../images/magno/49a.png";
import test49bpng from "../images/magno/49b.png";
import test49cpng from "../images/magno/49c.png";
import test49dpng from "../images/magno/49d.png";

import test50apng from "../images/magno/50a.png";
import test50bpng from "../images/magno/50b.png";
import test50cpng from "../images/magno/50c.png";

import test51apng from "../images/magno/51a.png";
import test51bpng from "../images/magno/51b.png";
import test51cpng from "../images/magno/51c.png";
import test51dpng from "../images/magno/51d.png";

import test52apng from "../images/magno/52a.png";
import test52bpng from "../images/magno/52b.png";
import test52cpng from "../images/magno/52c.png";
import test52dpng from "../images/magno/52d.png";

import test53apng from "../images/magno/53a.png";
import test53bpng from "../images/magno/53b.png";
import test53cpng from "../images/magno/53c.png";

import test54apng from "../images/capo/54a.png";
import test54bpng from "../images/capo/54b.png";
import test54cpng from "../images/capo/54c.png";

import test55apng from "../images/capo/55a.png";
import test55bpng from "../images/capo/55b.png";
import test55cpng from "../images/capo/55c.png";

import test56apng from "../images/capo/56a.png";
import test56bpng from "../images/capo/56b.png";
import test56cpng from "../images/capo/56c.png";

import test57apng from "../images/capo/57a.png";
import test57bpng from "../images/capo/57b.png";
import test57cpng from "../images/capo/57c.png";

import test58apng from "../images/capo/58a.png";
import test58bpng from "../images/capo/58b.png";
import test58cpng from "../images/capo/58c.png";

import test59apng from "../images/capo/59a.png";
import test59bpng from "../images/capo/59b.png";
import test59cpng from "../images/capo/59c.png";

import test60apng from "../images/fukuda/60a.png";
import test60bpng from "../images/fukuda/60b.png";
import test60cpng from "../images/fukuda/60c.png";
import test60dpng from "../images/fukuda/60d.png";
import test60epng from "../images/fukuda/60e.png";
import test60fpng from "../images/fukuda/60f.png";
import test60gpng from "../images/fukuda/60g.png";

import test61apng from "../images/fukuda/61a.png";
import test61bpng from "../images/fukuda/61b.png";
import test61cpng from "../images/fukuda/61c.png";

import test62apng from "../images/fukuda/61a.png";
import test62bpng from "../images/fukuda/62b.png";

import test63apng from "../images/fukuda/61a.png";
import test63bpng from "../images/fukuda/63b.png";

import test64apng from "../images/fukuda/61a.png";
import test64bpng from "../images/fukuda/62b.png";

import test68apng from "../images/adams/68a.png";
import test68bpng from "../images/adams/68b.png";
import test68cpng from "../images/adams/68c.png";
import test68dpng from "../images/adams/68d.png";
import test68epng from "../images/adams/68e.png";
import test68fpng from "../images/adams/68f.png";

import test69apng from "../images/adams/69a.png";
import test69bpng from "../images/adams/69b.png";
import test69cpng from "../images/adams/69c.png";
import test69dpng from "../images/adams/69d.png";

import test70apng from "../images/romberg/70a.png";
import test70bpng from "../images/romberg/70b.png";
import test70cpng from "../images/romberg/70c.png";

import test71apng from "../images/romberg/70a.png";
import test71bpng from "../images/romberg/71b.png";
import test71cpng from "../images/romberg/71c.png";

import test72apng from "../images/romberg/70a.png";
import test72bpng from "../images/romberg/72b.png";

import test73apng from "../images/vision/73a.png";
import test73bpng from "../images/vision/73b.png";

import test74apng from "../images/vision/74a.png";
import test74bpng from "../images/vision/74b.png";
import test74cpng from "../images/vision/74c.png";

import test75apng from "../images/vision/75a.png";
import test75bpng from "../images/vision/75b.png";
import test75cpng from "../images/vision/75c.png";

import test76apng from "../images/vision/76a.png";
import test76bpng from "../images/vision/76b.png";

import test78apng from "../images/vision/78a.png";
import test78bpng from "../images/vision/78b.png";

import test79apng from "../images/vision/79a.png";
import test79bpng from "../images/vision/79b.png";
import test79cpng from "../images/vision/79c.png";
import test79dpng from "../images/vision/79d.png";
import test79epng from "../images/vision/79e.png";

import test80apng from "../images/vision/80a.png";
import test80bpng from "../images/vision/80b.png";
import test80cpng from "../images/vision/80c.png";

import test81apng from "../images/vision/81a.png";
import test81bpng from "../images/vision/81b.png";
import test81cpng from "../images/vision/81c.png";

import test84apng from "../images/vision/84a.png";
import test84bpng from "../images/vision/84b.png";

import test85apng from "../images/vision/85a.png";
import test85bpng from "../images/vision/85b.png";

import test87apng from "../images/vision/87a.png";
import test87bpng from "../images/vision/87b.png";
import test87cpng from "../images/vision/87c.png";
import test87dpng from "../images/vision/87d.png";
import test87epng from "../images/vision/87e.png";
import test87fpng from "../images/vision/87f.png";
import test87gpng from "../images/vision/87g.png";
import test87hpng from "../images/vision/87h.png";
import test87ipng from "../images/vision/87i.png";

import test88apng from "../images/vision/88a.png";
import test88bpng from "../images/vision/88b.png";
import test88cpng from "../images/vision/88c.png";
import test88dpng from "../images/vision/88d.png";
import test88epng from "../images/vision/88e.png";
import test88fpng from "../images/vision/88f.png";
import test88gpng from "../images/vision/88g.png";
import test88hpng from "../images/vision/88h.png";
import test88ipng from "../images/vision/88i.png";
import test88lpng from "../images/vision/88l.png";
import test88mpng from "../images/vision/88m.png";

import test89apng from "../images/vision/89a.png";
import test89bpng from "../images/vision/89b.png";
import test89cpng from "../images/vision/89c.png";
import test89dpng from "../images/vision/89d.png";
import test89epng from "../images/vision/89e.png";
import test89fpng from "../images/vision/89f.png";
import test89gpng from "../images/vision/89g.png";
import test89hpng from "../images/vision/89h.png";
import test89ipng from "../images/vision/89i.png";
import test89lpng from "../images/vision/89l.png";
import test89mpng from "../images/vision/89m.png";

import test91apng from "../images/rate/91a.png";
import test91bpng from "../images/rate/91b.png";
import test91cpng from "../images/rate/91c.png";

import test92apng from "../images/rate/92a.png";
import test92bpng from "../images/rate/92b.png";
import test92cpng from "../images/rate/92c.png";
import test92dpng from "../images/rate/92d.png";
import test92epng from "../images/rate/92e.png";

import test93apng from "../images/rate/93a.png";
import test93bpng from "../images/rate/93b.png";
import test93cpng from "../images/rate/93c.png";

import test94apng from "../images/rate/94a.png";
import test94bpng from "../images/rate/94b.png";
import test94cpng from "../images/rate/94c.png";

import test95apng from "../images/rate/95a.png";
import test95bpng from "../images/rate/95b.png";
import test95cpng from "../images/rate/95c.png";

import test96apng from "../images/rate/96a.png";
import test96bpng from "../images/rate/96b.png";
import test96cpng from "../images/rate/96c.png";

import test97apng from "../images/rate/97a.png";
import test97bpng from "../images/rate/97b.png";
import test97cpng from "../images/rate/97c.png";

import test98apng from "../images/rate/98a.png";
import test98bpng from "../images/rate/98b.png";
import test98cpng from "../images/rate/98c.png";

import test99apng from "../images/rate/99a.png";
import test99bpng from "../images/rate/99b.png";
import test99cpng from "../images/rate/99c.png";

import test100apng from "../images/rate/100a.png";
import test100bpng from "../images/rate/100b.png";

import test101apng from "../images/anam/101a.png";

import test102apng from "../images/anam/102a.png";

import test103apng from "../images/anam/103a.png";

import test104apng from "../images/anam/104a.png";

import test105apng from "../images/anam/105a.png";

import test106apng from "../images/anam/106a.png";

import test107apng from "../images/anam/107a.png";
import test107bpng from "../images/anam/107b.png";

import test108apng from "../images/anam/108a.png";
import test108bpng from "../images/anam/108b.png";

import test109apng from "../images/anam/109a.png";

import test110apng from "../images/anam/110a.png";

import test111apng from "../images/anam/111a.png";

import test112apng from "../images/anam/112a.png";
import test112bpng from "../images/anam/112b.png";

import test113apng from "../images/anam/113a.png";
import test113bpng from "../images/anam/113b.png";
import test113cpng from "../images/anam/113c.png";
import test113dpng from "../images/anam/113d.png";

import test114apng from "../images/anam/114a.png";
import test114bpng from "../images/anam/114b.png";
import test114cpng from "../images/anam/114c.png";
import test114dpng from "../images/anam/114d.png";
import test114epng from "../images/anam/114e.png";

import test115apng from "../images/anam/115a.png";
import test115bpng from "../images/anam/115b.png";

import test116apng from "../images/anam/116a.png";
import test116bpng from "../images/anam/116b.png";
import test116cpng from "../images/anam/116c.png";
import test116dpng from "../images/anam/116d.png";
import test116epng from "../images/anam/116e.png";
import test116fpng from "../images/anam/116f.png";
import test116gpng from "../images/anam/116g.png";
import test116hpng from "../images/anam/116h.png";
import test116ipng from "../images/anam/116i.png";
import test116lpng from "../images/anam/116l.png";
import test116mpng from "../images/anam/116m.png";

import test117apng from "../images/anam/117a.png";
import test117bpng from "../images/anam/117b.png";

import test118apng from "../images/anam/118a.png";
import test118bpng from "../images/anam/118b.png";

import test119apng from "../images/anam/119a.png";
import test119bpng from "../images/anam/119b.png";

import test120apng from "../images/anam/120a.png";

import test121apng from "../images/anam/121a.png";

import test122apng from "../images/anam/122a.png";

import test123apng from "../images/anam/123a.png";

import test124apng from "../images/tinetti/124a.png";
import test124bpng from "../images/tinetti/124b.png";
import test124cpng from "../images/tinetti/124c.png";

import test125apng from "../images/eli/125a.png";
import test125bpng from "../images/eli/125b.png";
import test125cpng from "../images/eli/125c.png";
import test125dpng from "../images/eli/125d.png";
import test125epng from "../images/eli/125e.png";
import test125fpng from "../images/eli/125f.png";
import test125gpng from "../images/eli/125g.png";

import test126apng from "../images/eli/126a.png";
import test126bpng from "../images/eli/126b.png";
import test126cpng from "../images/eli/126c.png";

import test127apng from "../images/eli/126a.png";
import test127bpng from "../images/eli/127b.png";

import test128apng from "../images/eli/126a.png";
import test128bpng from "../images/eli/128b.png";

import test129apng from "../images/eli/126a.png";
import test129bpng from "../images/eli/127b.png";

import test130apng from "../images/eli/130a.png";
import test130bpng from "../images/eli/130b.png";
import test130cpng from "../images/eli/130c.png";

import test131apng from "../images/eli/131a.png";
import test131bpng from "../images/eli/131b.png";
import test131cpng from "../images/eli/131c.png";

import test132apng from "../images/eli/132a.png";

import test133apng from "../images/eli/133a.png";
import test133bpng from "../images/eli/133b.png";
import test133cpng from "../images/eli/133c.png";

import test134apng from "../images/eli/134a.png";
import test134bpng from "../images/eli/134b.png";
import test134cpng from "../images/eli/134c.png";

import test135apng from "../images/eli/135a.png";
import test135bpng from "../images/eli/135b.png";
import test135cpng from "../images/eli/135c.png";
import test135dpng from "../images/eli/135d.png";
import test135epng from "../images/eli/135e.png";
import test135fpng from "../images/eli/135f.png";

import test136apng from "../images/eli/136a.png";
import test136bpng from "../images/eli/136b.png";
import test136cpng from "../images/eli/136c.png";

const testOptionImages = [
  [test0apng, test0bpng, test0cpng], //test0 4foto
  [test1apng, test1bpng, test1cpng], //test1 4foto
  [test2apng, test2bpng, test2cpng], //test2 4foto
  [test3apng, test3bpng, test3cpng], //test3 4foto
  [test4apng, test4bpng, test4cpng], //test4 4foto
  [test5apng, test5bpng, test5cpng], //test5 4foto
  [test6apng, test6bpng, test6cpng], //test6 4foto
  [test7apng, test7bpng, test7cpng], //test7 4foto
  [test8apng, test8bpng, test8cpng, test8dpng, test8epng], //test8 4foto
  [test9apng, test9bpng, test9cpng], //test9 4foto
  [test10apng, test10bpng, test10cpng], //test10 4foto
  [test11apng, test11bpng, test11cpng], //test11 4foto

  [test12apng, test12bpng, test12cpng], //test12 podo
  [
    test13apng,
    test13bpng,
    test13cpng,
    test13dpng,
    test13epng,
    test13fpng,
    test13gpng,
  ], //test13 podo
  [
    test14apng,
    test14bpng,
    test14cpng,
    test14dpng,
    test14epng,
    test14fpng,
    test14gpng,
  ], //test14 podo
  [test15apng, test15bpng, test15cpng], //test15 podo

  [test16apng, test16bpng, test16cpng, test16dpng], //test16aaii
  [test17apng, test17bpng, test17cpng, test17dpng], //test17aaii
  [test18apng, test18bpng, test18cpng], //test18 aaii
  [test19apng, test19bpng, test19cpng], //test19 aaii
  [test20apng, test20bpng, test20cpng], //test20 aaii
  [test21apng, test21bpng, test21cpng], //test21 aaii
  [test22apng, test22bpng, test22cpng], //test22 aaii
  [test23apng, test23bpng, test23cpng], //test23 aaii
  [test24apng, test24bpng, test24cpng], //test24 aaii
  [test25apng, test25bpng, test25cpng], //test25 aaii
  [test26apng, test26bpng, test26cpng], //test26 aaii
  [test27apng, test27bpng, test27cpng], //test27 aaii
  [test28apng, test28bpng, test28cpng], //test28 aaii

  [test29apng, test29bpng, test29cpng], //test29 vision
  [test30apng, test30bpng, test30cpng, test30dpng], //test30 vision

  [test31apng, test31bpng, test31cpng, test31dpng, test31epng], //test31 stim

  [test32apng, test32bpng], //test32 stim
  [test33apng, test33bpng], //test33 stim
  [test34apng, test34bpng, test34cpng, test34dpng], //test34 stim
  [test35apng], //test35 stim
  [test36apng], //test36 stim

  [],
  [],
  [],
  [],

  [test41apng, test41bpng, test41cpng], //test 41 magno
  [test42apng, test42bpng, test42cpng], //test 42 magno
  [test43apng, test43bpng, test43cpng], //test 43 magno
  [test44apng, test44bpng, test44cpng], //test 44 magno
  [test45apng, test45bpng, test45cpng], //test 45 magno
  [test46apng, test46bpng], //test 46 magno
  [],
  [test48apng, test48bpng], //test 48 magno
  [test49apng, test49bpng, test49cpng, test49dpng], //test 49 magno
  [test50apng, test50bpng, test50cpng], //test 50 magno
  [test51apng, test51bpng, test51cpng, test51dpng], //test 51 magno
  [test52apng, test52bpng, test52cpng, test52dpng], //test 52 magno
  [test53apng, test53bpng, test53cpng], //test 53 magno

  [test54apng, test54bpng, test54cpng], //test 54 capo
  [test55apng, test55bpng, test55cpng], //test 55 capo
  [test56apng, test56bpng, test56cpng], //test 56 capo
  [test57apng, test57bpng, test57cpng], //test 57 capo
  [test58apng, test58bpng, test58cpng], //test 58 capo
  [test59apng, test59bpng, test59cpng], //test 59 capo

  [
    test60apng,
    test60bpng,
    test60cpng,
    test60dpng,
    test60epng,
    test60fpng,
    test60gpng,
  ], //test 60 fukuda
  [test61apng, test61bpng, test61cpng], //test 61 fukuda
  [test62apng, test62bpng], //test 62 fukuda
  [test63apng, test63bpng], //test 63 fukuda
  [test64apng, test64bpng], //test 64 fukuda

  [],
  [],
  [],

  [test68apng, test68bpng, test68cpng, test68dpng, test68epng, test68fpng], //test 68 adams
  [test69apng, test69bpng, test69cpng, test69dpng], //test 69 adams

  [test70apng, test70bpng, test70cpng], //test 70 romberg
  [test71apng, test71bpng, test71cpng], //test 71 romberg
  [test72apng, test72bpng], //test 72 romberg

  [test73apng, test73bpng], //test73 vision
  [test74apng, test74bpng, test74cpng], //test74 vision
  [test75apng, test75bpng, test75cpng], //test75 vision
  [test76apng, test76bpng], //test76 vision
  [],
  [test78apng, test78bpng], //test78 vision
  [test79apng, test79bpng, test79cpng, test79dpng, test79epng], //test78 vision
  [test80apng, test80bpng, test80cpng], //test80 vision
  [test81apng, test81bpng, test81cpng], //test81 vision
  [],
  [],
  [test84apng, test84bpng], //test84 vision
  [test85apng, test85bpng], //test85 vision
  [],
  [
    test87apng,
    test87bpng,
    test87cpng,
    test87dpng,
    test87epng,
    test87fpng,
    test87gpng,
    test87hpng,
    test87ipng,
  ], //test87 vision
  [
    test88apng,
    test88bpng,
    test88cpng,
    test88dpng,
    test88epng,
    test88fpng,
    test88gpng,
    test88hpng,
    test88ipng,
    test88lpng,
    test88mpng,
  ], //test88 vision
  [
    test89apng,
    test89bpng,
    test89cpng,
    test89dpng,
    test89epng,
    test89fpng,
    test89gpng,
    test89hpng,
    test89ipng,
    test89lpng,
    test89mpng,
  ], //test89 vision
  [],
  [test91apng, test91bpng, test91cpng], //test 91 rate
  [test92apng, test92bpng, test92cpng, test92dpng, test92epng], //test 92 rate
  [test93apng, test93bpng, test93cpng], //test 93 rate
  [test94apng, test94bpng, test94cpng], //test 94 rate
  [test95apng, test95bpng, test95cpng], //test 95 rate
  [test96apng, test96bpng, test96cpng], //test 96 rate
  [test97apng, test97bpng, test97cpng], //test 97 rate

  [test98apng, test98bpng, test98cpng], //test 98 rate
  [test99apng, test99bpng, test99cpng], //test 99 rate
  [test100apng, test100bpng], //test 100 rate

  [test101apng], //test 101 anam
  [test102apng], //test 102 anam
  [test103apng], //test 103 anam

  [test104apng], //test 104 anam
  [test105apng], //test 105 anam
  [test106apng], //test 106 anam

  [test107apng, test107bpng], //test 107 anam
  [test108apng, test108bpng], //test 108 anam

  [test109apng], //test 109 anam
  [test110apng], //test 110 anam
  [test111apng], //test 111 anam

  [test112apng, test112bpng], //test 112 anam
  [test113apng, test113bpng, test113cpng, test113dpng], //test 113 anam
  [test114apng, test114bpng, test114cpng, test114dpng, test114epng], //test 114 anam
  [test115apng, test115bpng], //test 115 anam
  [
    test116apng,
    test116bpng,
    test116cpng,
    test116dpng,
    test116epng,
    test116fpng,
    test116gpng,
    test116hpng,
    test116ipng,
    test116lpng,
    test116mpng,
  ], //test 116 anam

  [test117apng, test117bpng], //test 117 anam
  [test118apng, test118bpng], //test 118 anam
  [test119apng, test119bpng], //test 119 anam

  [test120apng], //test 120 anam
  [test121apng], //test 121 anam
  [test122apng], //test 122 anam
  [test123apng], //test 123 anam

  [test124apng, test124bpng, test124cpng], //test 124 tinetti

  [
    test125apng,
    test125bpng,
    test125cpng,
    test125dpng,
    test125epng,
    test125fpng,
    test125gpng,
  ], //test 125 elicoidale
  [test126apng, test126bpng, test126cpng], //test 126 elicoidale
  [test127apng, test127bpng], //test 127 elicoidale
  [test128apng, test128bpng], //test 128 elicoidale
  [test129apng, test129bpng], //test 129 elicoidale
  [test130apng, test130bpng, test130cpng], //test 130 elicoidale
  [test131apng, test131bpng, test131cpng], //test 131 elicoidale
  [test132apng], //test 132 elicoidale
  [test133apng, test133bpng, test133cpng], //test 133 elicoidale
  [test134apng, test134bpng, test134cpng], //test 134 elicoidale
  [
    test135apng,
    test135bpng,
    test135cpng,
    test135dpng,
    test135epng,
    test135fpng,
  ], //test 135 elicoidale
  [test136apng, test136bpng, test136cpng], //test 136 elicoidale
];

import {
  PosturalExaminationSelection,
  PosturalTestDefinition,
} from "./interfaces";

const parseToBase2Array = (selection: number, nOptions: number) => {
  // console.log("HHH " + selection + " " + nOptions);
  const selected = Array(nOptions).fill(0);
  let selectionB2String = selection >= 0 ? selection.toString(2) : "0000000";
  while (selectionB2String.length < nOptions)
    selectionB2String = "0" + selectionB2String;
  // console.log(selectionB2String);
  for (let i = 0; i < nOptions; i++) {
    selected[i] = parseInt(selectionB2String[i]);
    if (isNaN(selected[i])) selected[i] = 0;
  }
  // selected.reverse();
  return selected;
};

const parseBase2Array = (selection: number[]) => {
  let selectionString = "";
  for (const s of selection) selectionString += s;

  return parseInt(selectionString, 2);
};

const buildTestNoteFromMultipleSelections = (
  prefixNote: string,
  selected: number[],
  testDefinition?: PosturalTestDefinition
) => {
  if (
    testDefinition &&
    selected.length > 0 &&
    selected.length == testDefinition.posturalTestOptions.length
  ) {
    let selections = "";
    for (let i = 0; i < selected.length; i++)
      if (selected[i] > 0)
        selections +=
          (i > 0 && selections.length > 0 ? ", " : "") +
          testDefinition.posturalTestOptions[i].pictureAlt;
    return prefixNote + " " + selections;
  }
  return "";
};

const TestOption = ({
  index,
  selected,
  prefixNote,
  setSelected,
  updTestNote,
  testDefinition,
  allInOneLine,
  allowMultiSelection,
}: {
  index: number;
  selected: number | number[];
  prefixNote: string;
  setSelected: Function;
  updTestNote: Function;
  testDefinition?: PosturalTestDefinition;
  allInOneLine?: boolean;
  allowMultiSelection?: boolean;
}) => {
  let testImages: string[] = testDefinition
    ? testOptionImages[testDefinition.id]
    : [];

  let spanSize = 0;
  if (testDefinition)
    spanSize =
      testDefinition.posturalTestOptions.length < 3
        ? 12
        : testDefinition.posturalTestOptions.length == 4
        ? 6
        : testDefinition.posturalTestOptions.length == 5
        ? 4
        : 8;
  const content = (
    <>
      {testDefinition && testDefinition.posturalTestOptions.length > index && (
        <Tooltip
          placement="top"
          title={
            testDefinition &&
            testDefinition.posturalTestOptions.length > index &&
            testDefinition.posturalTestOptions[index].pictureAlt
          }
        >
          <Image
            className="test-option-img-btn col-test-option"
            style={{
              backgroundColor:
                (!allowMultiSelection && selected == index) ||
                (allowMultiSelection &&
                  Array.isArray(selected) &&
                  selected[index] > 0)
                  ? "#e6c3bc"
                  : "#dee9e4",

              maxWidth: "256px",
              maxHeight: "256px",
            }}
            onClick={() => {
              setSelected(index);

              if (!allowMultiSelection) {
                const testNote: string =
                  prefixNote +
                  (testDefinition &&
                  testDefinition.posturalTestOptions.length > index
                    ? testDefinition.posturalTestOptions[index].pictureAlt
                    : "");
                updTestNote(testNote);
              } else if (Array.isArray(selected)) {
                const testNote = buildTestNoteFromMultipleSelections(
                  prefixNote,
                  selected.map((el, i) => (i == index ? 1 - selected[i] : el)),
                  testDefinition
                );
                updTestNote(testNote);
              }
            }}
            src={testImages.length > index ? testImages[index] : ""}
            preview={false}
          />
        </Tooltip>
      )}
    </>
  );
  if (allInOneLine)
    return <Col style={{ textAlign: "center", margin: "auto" }}>{content}</Col>;
  return <Col span={spanSize}>{content}</Col>;
};

const TestUI = ({
  testSelection,
  setTestSelection,
  testDefinition,
  allInOneLine,
  allowMultiSelection,
}: {
  testSelection?: PosturalExaminationSelection;
  setTestSelection: Function;
  testDefinition?: PosturalTestDefinition;
  allInOneLine?: boolean;
  allowMultiSelection?: boolean;
}) => {
  if (testDefinition) {
    const prefixNote: string =
      (testSelection?.prefixNote ||
        //"Test" +
        //  (testDefinition ? testDefinition?.id + "" : "") +
        "[" + testDefinition?.posturalTestName + "]") + ": ";
    const [selected, setSelected] = useState<number | number[]>(
      testSelection && !allowMultiSelection
        ? testSelection.selectedValue
        : testSelection
        ? parseToBase2Array(
            testSelection.selectedValue,
            testDefinition.posturalTestOptions.length
          )
        : -1
    );
    const [testNote, setTestNote] = useState<string>(
      testSelection && testSelection.note != undefined ? testSelection.note : ""
    );

    useEffect(() => {
      if (Array.isArray(selected) && allowMultiSelection) {
        if (Array.isArray(selected) && allowMultiSelection)
          // console.log(selected, parseBase2Array(selected));
          setTestSelection(
            testDefinition?.id,
            parseBase2Array(selected),
            testNote
          );
      } else if (Number.isInteger(selected))
        setTestSelection(testDefinition?.id, selected, testNote);
    }, [testNote]);

    return (
      <div className="centered">
        <Row className="ant-row-exam">
          {testDefinition &&
            testDefinition.posturalTestOptions &&
            testDefinition.posturalTestOptions.length > 0 &&
            new Array(testDefinition.posturalTestOptions.length)
              .fill(0)
              .map((el, index) => (
                <TestOption
                  key={index + prefixNote}
                  allInOneLine={allInOneLine}
                  index={index}
                  selected={selected}
                  prefixNote={prefixNote}
                  testDefinition={testDefinition}
                  setSelected={(sel: number) => {
                    if (!allowMultiSelection) setSelected(sel);
                    else if (allowMultiSelection && Array.isArray(selected)) {
                      const newSelected = [...selected];
                      newSelected[sel] = newSelected[sel] == 0 ? 1 : 0;
                      setSelected(newSelected);
                    }
                  }}
                  updTestNote={(newNote: string) => setTestNote(newNote)}
                  allowMultiSelection={allowMultiSelection}
                />
              ))}
        </Row>
        <Row style={{ marginTop: "5px" }}>
          <Col span={24}>
            <TextArea
            style={{ borderRadius: "15px", marginBottom: "5px" }}
              placeholder={testDefinition && testDefinition.posturalTestName}
              value={testNote}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                setTestNote(e.target.value)
              }
              maxLength={1024} //to modify note 128
              showCount
            />
          </Col>
        </Row>
      </div>
    );
  } else return <>Missing test definition</>;
};

export default TestUI;

const stimOptionImages = [
  [_1st1, _1st15, _1st2, _1st25, _1st3],
  [_3st1, _3st15, _3st2, _3st25, _3st3],
  [_4st1, _4st15, _4st2, _4st25, _4st3],
  [_5st1, _5st15, _5st2, _5st25, _5st3],
  [_6st1, _6st15, _6st2, _6st25, _6st3],
  [_7st1, _7st15, _7st2, _7st25, _7st3],
  [_8st1, _8st15, _8st2, _8st25, _8st3],
];

export const TestUIStim = ({
  testSelections,
  setTestSelection,
  testDefinitions,
}: {
  testSelections?: PosturalExaminationSelection[];
  setTestSelection: Function;
  testDefinitions?: PosturalTestDefinition[];
}) => {
  const [testNoteSx, setTestNoteSx] = useState<string>(
    testSelections &&
      testSelections.length > 0 &&
      testSelections[0].note != undefined
      ? testSelections[0].note.indexOf("[Spessori sx]: ") == 0
        ? testSelections[0].note.substring("[Spessori sx]: ".length)
        : testSelections[0].note
      : ""
  );
  const [testNoteDx, setTestNoteDx] = useState<string>(
    testSelections &&
      testSelections.length > 1 &&
      testSelections[1].note != undefined
      ? testSelections[1].note.indexOf("[Spessori dx]: ") == 0
        ? testSelections[1].note.substring("[Spessori dx]: ".length)
        : testSelections[1].note
      : ""
  );

  const parseNoteToSelection = (note: string) => {
    let ret = Array(7).fill(2.0);
    if (note.indexOf("1ST: ") >= 0)
      ret[0] = parseFloat(note.substring(note.indexOf("1ST: ") + 5));
    if (note.indexOf("3ST: ") >= 0)
      ret[1] = parseFloat(note.substring(note.indexOf("3ST: ") + 5));
    if (note.indexOf("4ST: ") >= 0)
      ret[2] = parseFloat(note.substring(note.indexOf("4ST: ") + 5));
    if (note.indexOf("5ST: ") >= 0)
      ret[3] = parseFloat(note.substring(note.indexOf("5ST: ") + 5));
    if (note.indexOf("6ST: ") >= 0)
      ret[4] = parseFloat(note.substring(note.indexOf("6ST: ") + 5));
    if (note.indexOf("7ST: ") >= 0)
      ret[5] = parseFloat(note.substring(note.indexOf("7ST: ") + 5));
    if (note.indexOf("8ST: ") >= 0)
      ret[6] = parseFloat(note.substring(note.indexOf("8ST: ") + 5));
    // console.log("parseNoteToSelection: " + JSON.stringify(ret));
    return ret;
  };

  const parseNoteToChecked = (note: string) => {
    // console.log(note);
    let ret = Array(7).fill(false);
    ret[0] = note.indexOf("1ST: ") >= 0;
    ret[1] = note.indexOf("3ST: ") >= 0;
    ret[2] = note.indexOf("4ST: ") >= 0;
    ret[3] = note.indexOf("5ST: ") >= 0;
    ret[4] = note.indexOf("6ST: ") >= 0;
    ret[5] = note.indexOf("7ST: ") >= 0;
    ret[6] = note.indexOf("8ST: ") >= 0;
    // console.log("parseNoteToChecked: " + JSON.stringify(ret));
    return ret;
  };

  const [selectionsDx, setSelectionsDx] = useState<number[]>(
    testSelections &&
      testSelections[1].note != undefined &&
      testSelections[1].note.length > 0
      ? parseNoteToSelection(testSelections[1].note)
      : Array(7).fill(2.0)
  );
  const [selectionsSx, setSelectionsSx] = useState<number[]>(
    testSelections &&
      testSelections[0].note != undefined &&
      testSelections[0].note.length > 0
      ? parseNoteToSelection(testSelections[0].note)
      : Array(7).fill(2.0)
  );

  const [checkedDx, setCheckedDx] = useState<boolean[]>(Array(7).fill(false));
  const [checkedSx, setCheckedSx] = useState<boolean[]>(Array(7).fill(false));
  useEffect(() => {
    if (
      testSelections &&
      testSelections[1].note != undefined &&
      testSelections[1].note.length > 0
    )
      setCheckedDx(parseNoteToChecked(testSelections[1].note));
    if (
      testSelections &&
      testSelections[0].note != undefined &&
      testSelections[0].note.length > 0
    )
      setCheckedSx(parseNoteToChecked(testSelections[0].note));
  }, []);

  const parseValueToStimVal = (val: string) => {
    let ret = parseFloat(val);
    if (ret == 1.0 || ret == 1.5 || ret == 2.0 || ret == 2.5 || ret == 3.0)
      return ret;
    else if (ret < 1.0) return 1.0;
    else return 3.0;
  };

  const getStimImage = (index: number, value: number) => {
    switch (value) {
      case 1.0:
        return stimOptionImages[index][0];
      case 1.5:
        return stimOptionImages[index][1];
      case 2.0:
        return stimOptionImages[index][2];
      case 2.5:
        return stimOptionImages[index][3];
      case 3.0:
        return stimOptionImages[index][4];
      default:
        return "";
    }
  };

  const parseSelectionToStimString = (
    selection: number[],
    checked: boolean[]
  ) => {
    if (selection.length != 7 || checked.length != 7) return "";
    let ret = "";
    ret += checked[0] ? "1ST: " + selection[0] + "; " : "";
    ret += checked[1] ? "3ST: " + selection[1] + "; " : "";
    ret += checked[2] ? "4ST: " + selection[2] + "; " : "";
    ret += checked[3] ? "5ST: " + selection[3] + "; " : "";
    ret += checked[4] ? "6ST: " + selection[4] + "; " : "";
    ret += checked[5] ? "7ST: " + selection[5] + "; " : "";
    ret += checked[6] ? "8ST: " + selection[6] + "; " : "";
    return ret;
  };

  useEffect(() => {
    setTestNoteSx(parseSelectionToStimString(selectionsSx, checkedSx));
  }, [selectionsSx, checkedSx]);

  useEffect(() => {
    setTestNoteDx(parseSelectionToStimString(selectionsDx, checkedDx));
  }, [selectionsDx, checkedDx]);

  useEffect(() => {
    if (testDefinitions && testDefinitions[0])
      setTestSelection(
        testDefinitions[0].id,
        0,
        "[Spessori sx]: " + testNoteSx
      );
  }, [testNoteSx]);

  useEffect(() => {
    if (testDefinitions && testDefinitions[1])
      setTestSelection(
        testDefinitions[1].id,
        0,
        "[Spessori dx]: " + testNoteDx
      );
  }, [testNoteDx]);

  if (testDefinitions) {
    return (
      <div className="centered">
        <Row>
          <table className="stim-table">
            <thead>
              <tr>
                <th>Stimolo</th>
                <th>Piede sx</th>
                <th>Piede dx</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  Sottocapitario
                  <br />
                  <span style={{ fontWeight: "bold" }}>1ST</span>
                </td>
                <td>
                  <Row>
                    <Col span={"2"} style={{ marginTop: "24px" }}>
                      <Checkbox
                        checked={checkedSx[0]}
                        onChange={(e) => {
                          checkedSx[0] = !checkedSx[0];
                          setCheckedSx([...checkedSx]);
                        }}
                      ></Checkbox>
                    </Col>
                    <Col span={"10"}>
                      <Image
                        preview={false}
                        src={
                          checkedSx[0] ? getStimImage(0, selectionsSx[0]) : ""
                        }
                        style={{ minWidth: "40px", maxWidth: "40px" }}
                      />
                    </Col>
                    <Col span={"2"} />
                    <Col span={"8"} style={{ marginTop: "24px" }}>
                      <Input
                        type="number"
                        step="0.5"
                        min="1.0"
                        max="3.0"
                        disabled={!checkedSx[0]}
                        value={selectionsSx[0]}
                        onChange={(e) => {
                          selectionsSx[0] = parseValueToStimVal(e.target.value);
                          setSelectionsSx([...selectionsSx]);
                        }}
                      />
                    </Col>
                  </Row>
                </td>
                <td>
                  <Row>
                    <Col span={"2"} style={{ marginTop: "24px" }}>
                      <Checkbox
                        checked={checkedDx[0]}
                        onChange={(e) => {
                          checkedDx[0] = !checkedDx[0];
                          setCheckedDx([...checkedDx]);
                        }}
                      ></Checkbox>
                    </Col>
                    <Col span={"10"}>
                      <Image
                        className="h-flip"
                        preview={false}
                        src={
                          checkedDx[0] ? getStimImage(0, selectionsDx[0]) : ""
                        }
                        style={{ minWidth: "40px", maxWidth: "40px" }}
                      />
                    </Col>
                    <Col span={"2"} />
                    <Col span={"8"} style={{ marginTop: "24px" }}>
                      <Input
                        type="number"
                        step="0.5"
                        min="1.0"
                        max="3.0"
                        disabled={!checkedDx[0]}
                        value={selectionsDx[0]}
                        onChange={(e) => {
                          selectionsDx[0] = parseValueToStimVal(e.target.value);
                          setSelectionsDx([...selectionsDx]);
                        }}
                      />
                    </Col>
                  </Row>
                </td>
              </tr>
              <tr>
                <td>
                  Anti-varo anteriore
                  <br />
                  <span style={{ fontWeight: "bold" }}>3ST</span>
                </td>
                <td>
                  <Row>
                    <Col span={"2"} style={{ marginTop: "24px" }}>
                      <Checkbox
                        checked={checkedSx[1]}
                        onChange={(e) => {
                          checkedSx[1] = !checkedSx[1];
                          setCheckedSx([...checkedSx]);
                        }}
                      ></Checkbox>
                    </Col>
                    <Col span={"10"}>
                      <Image
                        preview={false}
                        src={
                          checkedSx[1] ? getStimImage(1, selectionsSx[1]) : ""
                        }
                        style={{ minWidth: "40px", maxWidth: "40px" }}
                      />
                    </Col>
                    <Col span={"2"} />
                    <Col span={"8"} style={{ marginTop: "24px" }}>
                      <Input
                        type="number"
                        step="0.5"
                        min="1.0"
                        max="3.0"
                        disabled={!checkedSx[1]}
                        value={selectionsSx[1]}
                        onChange={(e) => {
                          selectionsSx[1] = parseValueToStimVal(e.target.value);
                          setSelectionsSx([...selectionsSx]);
                        }}
                      />
                    </Col>
                  </Row>
                </td>
                <td>
                  <Row>
                    <Col span={"2"} style={{ marginTop: "24px" }}>
                      <Checkbox
                        checked={checkedDx[1]}
                        onChange={(e) => {
                          checkedDx[1] = !checkedDx[1];
                          setCheckedDx([...checkedDx]);
                        }}
                      ></Checkbox>
                    </Col>
                    <Col span={"10"}>
                      <Image
                        className="h-flip"
                        preview={false}
                        src={
                          checkedDx[1] ? getStimImage(1, selectionsDx[1]) : ""
                        }
                        style={{ minWidth: "40px", maxWidth: "40px" }}
                      />
                    </Col>
                    <Col span={"2"} />
                    <Col span={"8"} style={{ marginTop: "24px" }}>
                      <Input
                        type="number"
                        step="0.5"
                        min="1.0"
                        max="3.0"
                        disabled={!checkedDx[1]}
                        value={selectionsDx[1]}
                        onChange={(e) => {
                          selectionsDx[1] = parseValueToStimVal(e.target.value);
                          setSelectionsDx([...selectionsDx]);
                        }}
                      />
                    </Col>
                  </Row>
                </td>
              </tr>
              <tr>
                <td>
                  Anti-valgo anteriore
                  <br />
                  <span style={{ fontWeight: "bold" }}>4ST</span>
                </td>
                <td>
                  <Row>
                    <Col span={"2"} style={{ marginTop: "24px" }}>
                      <Checkbox
                        checked={checkedSx[2]}
                        onChange={(e) => {
                          checkedSx[2] = !checkedSx[2];
                          setCheckedSx([...checkedSx]);
                        }}
                      ></Checkbox>
                    </Col>
                    <Col span={"10"}>
                      <Image
                        preview={false}
                        src={
                          checkedSx[2] ? getStimImage(2, selectionsSx[2]) : ""
                        }
                        style={{ minWidth: "40px", maxWidth: "40px" }}
                      />
                    </Col>
                    <Col span={"2"} />
                    <Col span={"8"} style={{ marginTop: "24px" }}>
                      <Input
                        type="number"
                        step="0.5"
                        min="1.0"
                        max="3.0"
                        disabled={!checkedSx[2]}
                        value={selectionsSx[2]}
                        onChange={(e) => {
                          selectionsSx[2] = parseValueToStimVal(e.target.value);
                          setSelectionsSx([...selectionsSx]);
                        }}
                      />
                    </Col>
                  </Row>
                </td>
                <td>
                  <Row>
                    <Col span={"2"} style={{ marginTop: "24px" }}>
                      <Checkbox
                        checked={checkedDx[2]}
                        onChange={(e) => {
                          checkedDx[2] = !checkedDx[2];
                          setCheckedDx([...checkedDx]);
                        }}
                      ></Checkbox>
                    </Col>
                    <Col span={"10"}>
                      <Image
                        className="h-flip"
                        preview={false}
                        src={
                          checkedDx[2] ? getStimImage(2, selectionsDx[2]) : ""
                        }
                        style={{ minWidth: "40px", maxWidth: "40px" }}
                      />
                    </Col>
                    <Col span={"2"} />
                    <Col span={"8"} style={{ marginTop: "24px" }}>
                      <Input
                        type="number"
                        step="0.5"
                        min="1.0"
                        max="3.0"
                        disabled={!checkedDx[2]}
                        value={selectionsDx[2]}
                        onChange={(e) => {
                          selectionsDx[2] = parseValueToStimVal(e.target.value);
                          setSelectionsDx([...selectionsDx]);
                        }}
                      />
                    </Col>
                  </Row>
                </td>
              </tr>
              <tr>
                <td>
                  Anti-valgo posteriore
                  <br />
                  <span style={{ fontWeight: "bold" }}>5ST</span>
                </td>
                <td>
                  <Row>
                    <Col span={"2"} style={{ marginTop: "24px" }}>
                      <Checkbox
                        checked={checkedSx[3]}
                        onChange={(e) => {
                          checkedSx[3] = !checkedSx[3];
                          setCheckedSx([...checkedSx]);
                        }}
                      ></Checkbox>
                    </Col>
                    <Col span={"10"}>
                      <Image
                        preview={false}
                        src={
                          checkedSx[3] ? getStimImage(3, selectionsSx[3]) : ""
                        }
                        style={{ minWidth: "40px", maxWidth: "40px" }}
                      />
                    </Col>
                    <Col span={"2"} />
                    <Col span={"8"} style={{ marginTop: "24px" }}>
                      <Input
                        type="number"
                        step="0.5"
                        min="1.0"
                        max="3.0"
                        disabled={!checkedSx[3]}
                        value={selectionsSx[3]}
                        onChange={(e) => {
                          selectionsSx[3] = parseValueToStimVal(e.target.value);
                          setSelectionsSx([...selectionsSx]);
                        }}
                      />
                    </Col>
                  </Row>
                </td>
                <td>
                  <Row>
                    <Col span={"2"} style={{ marginTop: "24px" }}>
                      <Checkbox
                        checked={checkedDx[3]}
                        onChange={(e) => {
                          checkedDx[3] = !checkedDx[3];
                          setCheckedDx([...checkedDx]);
                        }}
                      ></Checkbox>
                    </Col>
                    <Col span={"10"}>
                      <Image
                        className="h-flip"
                        preview={false}
                        src={
                          checkedDx[3] ? getStimImage(3, selectionsDx[3]) : ""
                        }
                        style={{ minWidth: "40px", maxWidth: "40px" }}
                      />
                    </Col>
                    <Col span={"2"} />
                    <Col span={"8"} style={{ marginTop: "24px" }}>
                      <Input
                        type="number"
                        step="0.5"
                        min="1.0"
                        max="3.0"
                        disabled={!checkedDx[3]}
                        value={selectionsDx[3]}
                        onChange={(e) => {
                          selectionsDx[3] = parseValueToStimVal(e.target.value);
                          setSelectionsDx([...selectionsDx]);
                        }}
                      />
                    </Col>
                  </Row>
                </td>
              </tr>
              <tr>
                <td>
                  Anti-varo posteriore
                  <br />
                  <span style={{ fontWeight: "bold" }}>6ST</span>
                </td>
                <td>
                  <Row>
                    <Col span={"2"} style={{ marginTop: "24px" }}>
                      <Checkbox
                        checked={checkedSx[4]}
                        onChange={(e) => {
                          checkedSx[4] = !checkedSx[4];
                          setCheckedSx([...checkedSx]);
                        }}
                      ></Checkbox>
                    </Col>
                    <Col span={"10"}>
                      <Image
                        preview={false}
                        src={
                          checkedSx[4] ? getStimImage(4, selectionsSx[4]) : ""
                        }
                        style={{ minWidth: "40px", maxWidth: "40px" }}
                      />
                    </Col>
                    <Col span={"2"} />
                    <Col span={"8"} style={{ marginTop: "24px" }}>
                      <Input
                        type="number"
                        step="0.5"
                        min="1.0"
                        max="3.0"
                        disabled={!checkedSx[4]}
                        value={selectionsSx[4]}
                        onChange={(e) => {
                          selectionsSx[4] = parseValueToStimVal(e.target.value);
                          setSelectionsSx([...selectionsSx]);
                        }}
                      />
                    </Col>
                  </Row>
                </td>
                <td>
                  <Row>
                    <Col span={"2"} style={{ marginTop: "24px" }}>
                      <Checkbox
                        checked={checkedDx[4]}
                        onChange={(e) => {
                          checkedDx[4] = !checkedDx[4];
                          setCheckedDx([...checkedDx]);
                        }}
                      ></Checkbox>
                    </Col>
                    <Col span={"10"}>
                      <Image
                        className="h-flip"
                        preview={false}
                        src={
                          checkedDx[4] ? getStimImage(4, selectionsDx[4]) : ""
                        }
                        style={{ minWidth: "40px", maxWidth: "40px" }}
                      />
                    </Col>
                    <Col span={"2"} />
                    <Col span={"8"} style={{ marginTop: "24px" }}>
                      <Input
                        type="number"
                        step="0.5"
                        min="1.0"
                        max="3.0"
                        disabled={!checkedDx[4]}
                        value={selectionsDx[4]}
                        onChange={(e) => {
                          selectionsDx[4] = parseValueToStimVal(e.target.value);
                          setSelectionsDx([...selectionsDx]);
                        }}
                      />
                    </Col>
                  </Row>
                </td>
              </tr>
              <tr>
                <td>
                  Antigravitazionale
                  <br />
                  <span style={{ fontWeight: "bold" }}>7ST</span>
                </td>
                <td>
                  <Row>
                    <Col span={"2"} style={{ marginTop: "24px" }}>
                      <Checkbox
                        checked={checkedSx[5]}
                        onChange={(e) => {
                          checkedSx[5] = !checkedSx[5];
                          setCheckedSx([...checkedSx]);
                        }}
                      ></Checkbox>
                    </Col>
                    <Col span={"10"}>
                      <Image
                        preview={false}
                        src={
                          checkedSx[5] ? getStimImage(5, selectionsSx[5]) : ""
                        }
                        style={{ minWidth: "40px", maxWidth: "40px" }}
                      />
                    </Col>
                    <Col span={"2"} />
                    <Col span={"8"} style={{ marginTop: "24px" }}>
                      <Input
                        type="number"
                        step="0.5"
                        min="1.0"
                        max="3.0"
                        disabled={!checkedSx[5]}
                        value={selectionsSx[5]}
                        onChange={(e) => {
                          selectionsSx[5] = parseValueToStimVal(e.target.value);
                          setSelectionsSx([...selectionsSx]);
                        }}
                      />
                    </Col>
                  </Row>
                </td>
                <td>
                  <Row>
                    <Col span={"2"} style={{ marginTop: "24px" }}>
                      <Checkbox
                        checked={checkedDx[5]}
                        onChange={(e) => {
                          checkedDx[5] = !checkedDx[5];
                          setCheckedDx([...checkedDx]);
                        }}
                      ></Checkbox>
                    </Col>
                    <Col span={"10"}>
                      <Image
                        className="h-flip"
                        preview={false}
                        src={
                          checkedDx[5] ? getStimImage(5, selectionsDx[5]) : ""
                        }
                        style={{ minWidth: "40px", maxWidth: "40px" }}
                      />
                    </Col>
                    <Col span={"2"} />
                    <Col span={"8"} style={{ marginTop: "24px" }}>
                      <Input
                        type="number"
                        step="0.5"
                        min="1.0"
                        max="3.0"
                        disabled={!checkedDx[5]}
                        value={selectionsDx[5]}
                        onChange={(e) => {
                          selectionsDx[5] = parseValueToStimVal(e.target.value);
                          setSelectionsDx([...selectionsDx]);
                        }}
                      />
                    </Col>
                  </Row>
                </td>
              </tr>
              <tr>
                <td>
                  Sottocalcaneare
                  <br />
                  <span style={{ fontWeight: "bold" }}>8ST</span>
                </td>
                <td>
                  <Row>
                    <Col span={"2"} style={{ marginTop: "24px" }}>
                      <Checkbox
                        checked={checkedSx[6]}
                        onChange={(e) => {
                          checkedSx[6] = !checkedSx[6];
                          setCheckedSx([...checkedSx]);
                        }}
                      ></Checkbox>
                    </Col>
                    <Col span={"10"}>
                      <Image
                        preview={false}
                        src={
                          checkedSx[6] ? getStimImage(6, selectionsSx[6]) : ""
                        }
                        style={{ minWidth: "40px", maxWidth: "40px" }}
                      />
                    </Col>
                    <Col span={"2"} />
                    <Col span={"8"} style={{ marginTop: "24px" }}>
                      <Input
                        type="number"
                        step="0.5"
                        min="1.0"
                        max="3.0"
                        disabled={!checkedSx[6]}
                        value={selectionsSx[6]}
                        onChange={(e) => {
                          selectionsSx[6] = parseValueToStimVal(e.target.value);
                          setSelectionsSx([...selectionsSx]);
                        }}
                      />
                    </Col>
                  </Row>
                </td>
                <td>
                  <Row>
                    <Col span={"2"} style={{ marginTop: "24px" }}>
                      <Checkbox
                        checked={checkedDx[6]}
                        onChange={(e) => {
                          checkedDx[6] = !checkedDx[6];
                          setCheckedDx([...checkedDx]);
                        }}
                      ></Checkbox>
                    </Col>
                    <Col span={"10"}>
                      <Image
                        className="h-flip"
                        preview={false}
                        src={
                          checkedDx[6] ? getStimImage(6, selectionsDx[6]) : ""
                        }
                        style={{ minWidth: "40px", maxWidth: "40px" }}
                      />
                    </Col>
                    <Col span={"2"} />
                    <Col span={"8"} style={{ marginTop: "24px" }}>
                      <Input
                        type="number"
                        step="0.5"
                        min="1.0"
                        max="3.0"
                        disabled={!checkedDx[6]}
                        value={selectionsDx[6]}
                        onChange={(e) => {
                          selectionsDx[6] = parseValueToStimVal(e.target.value);
                          setSelectionsDx([...selectionsDx]);
                        }}
                      />
                    </Col>
                  </Row>
                </td>
              </tr>
              <tr style={{ minHeight: "40px" }}>
                <td className={"stim-td-special"}>Shortcut</td>
                <td>
                  <Row>
                    <Col span={"2"} style={{ marginTop: "24px" }}>
                      <Checkbox
                        defaultChecked={false}
                        checked={
                          checkedSx.reduce(
                            (count, ck) => (ck ? 1 : 0) + count,
                            0
                          ) == 7
                        }
                        onChange={(e) =>
                          setCheckedSx(Array(7).fill(e.target.checked))
                        }
                      ></Checkbox>
                    </Col>
                    <Col span={"10"}></Col>
                    <Col span={"2"} />
                    <Col span={"8"} style={{ marginTop: "24px" }}>
                      <Input
                        type="number"
                        step="0.5"
                        min="1.0"
                        max="3.0"
                        defaultValue={2.0}
                        onChange={(e) => {
                          setSelectionsSx(
                            Array(7).fill(parseValueToStimVal(e.target.value))
                          );
                        }}
                      />
                    </Col>
                  </Row>
                </td>
                <td>
                  <Row>
                    <Col span={"2"} style={{ marginTop: "24px" }}>
                      <Checkbox
                        checked={
                          checkedDx.reduce(
                            (count, ck) => (ck ? 1 : 0) + count,
                            0
                          ) == 7
                        }
                        onChange={(e) => {
                          // console.log("HEY");
                          setCheckedDx(Array(7).fill(e.target.checked));
                        }}
                      ></Checkbox>
                    </Col>
                    <Col span={"10"}></Col>
                    <Col span={"2"} />
                    <Col span={"8"} style={{ marginTop: "24px" }}>
                      <Input
                        type="number"
                        step="0.5"
                        min="1.0"
                        max="3.0"
                        defaultValue={2.0}
                        onChange={(e) => {
                          setSelectionsDx(
                            Array(7).fill(parseValueToStimVal(e.target.value))
                          );
                        }}
                      />
                    </Col>
                  </Row>
                </td>
              </tr>
              <tr>
                <td> Descrizione testuale </td>
                <td>
                  <TextArea
                    placeholder={
                      testDefinitions && testDefinitions[0].posturalTestName
                    }
                    value={testNoteSx}
                    maxLength={128}
                    showCount
                    contentEditable={false}
                  />
                </td>
                <td>
                  <TextArea
                    placeholder={
                      testDefinitions && testDefinitions[1].posturalTestName
                    }
                    value={testNoteDx}
                    maxLength={128}
                    showCount
                    contentEditable={false}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </Row>
        <Row style={{ marginTop: "4px" }}>
          <Col span={24}></Col>
        </Row>
      </div>
    );
  } else return <>Definizione del test mancante</>;
};

export const TestUIBl = ({
  testSelection,
  setTestSelection,
  testDefinition,
}: {
  testSelection?: PosturalExaminationSelection;
  setTestSelection: Function;
  testDefinition?: PosturalTestDefinition;
}) => {
  const [W1, setW1] = useState<number>(0.0);
  const [W2, setW2] = useState<number>(0.0);
  const [diff, setDiff] = useState<number>(0.0);

  useEffect(() => {
    if (
      testSelection &&
      testSelection.note != undefined &&
      testSelection.note.length > 0
    ) {
      if (testSelection.note.indexOf("sx:") >= 0)
        setW1(
          parseFloat(
            testSelection.note.substring(testSelection.note.indexOf("sx:") + 3)
          )
        );

      if (testSelection.note.indexOf("dx:") >= 0)
        setW2(
          parseFloat(
            testSelection.note.substring(testSelection.note.indexOf("dx:") + 3)
          )
        );
    }
  }, []);

  useEffect(() => {
    if (W1 == null || isNaN(W1) || isNaN(W2) || W2 == null) return;
    else {
      setDiff(W1 - W2);
      if (testDefinition)
        setTestSelection(
          testDefinition.id,
          0,
          "[" +
            testDefinition.posturalTestName +
            "]: " +
            (W1 - W2).toFixed(2) +
            " kg " +
            "(sx: " +
            W1.toFixed(2) +
            ", dx: " +
            W2.toFixed(2) +
            ")"
        );
    }
  }, [W1, W2]);

  return (
    <>
      <h2
        style={{
          fontWeight: "bolder",
        }}
      >
        Peso totale: {(W1 + W2).toFixed(2)} kg
      </h2>
      <Row>
        <Col span={12}>
          <h2>Peso SX</h2>
          <InputNumber
            style={{ width: "90%" }}
            size="large"
            min={1.0}
            step={0.1}
            max={260.0}
            defaultValue={0.0}
            addonAfter={"Kg"}
            onChange={(value: number | null) => {
              if (value !== null) {
                setW2(value);
              }
            }}
            value={W1}
          />
        </Col>
        <Col span={12}>
          <h2>Peso DX</h2>
          <InputNumber
            style={{ width: "90%" }}
            size="large"
            min={1.0}
            step={0.1}
            max={260.0}
            defaultValue={0.0}
            addonAfter={"Kg"}
            onChange={(value: number | null) => {
              if (value !== null) {
                setW2(value);
              }
            }}
            value={W2}
          />
        </Col>
      </Row>
      <div className="centered" style={{ marginTop: "16px" }}>
        <h2
          style={{
            fontWeight: "bolder",
            color: Math.abs(diff) > 0.99 ? "red" : "green",
          }}
        >
          Differenza: {diff != null && !isNaN(diff) ? diff.toFixed(2) : ""} kg
        </h2>
      </div>
    </>
  );
};
